import React from 'react'
import * as FieldTypes from '../Shared/FieldTypes/FieldTypes.js'
import { ApplicableRegulation } from './BasicUdiLists.js'

// Full regulation name
const FieldType_BasicUdiRegulation = ({ value }) => {
    if (!value)
        return <></>;
    return <>{ApplicableRegulation.find(r => r.value === value)?.text ?? value}</>;
};

// Basic UDI-DIs view of the UDIs page (UDIs/UDIs.js)
export const getBasicUDIsConfig = () => {

    let dataTableStructure = {};

    dataTableStructure.dataUrl = "/umbraco/api/ProductRegistrationsApi/BasicUDIs";
    dataTableStructure.getSingleItemUrl = "/umbraco/api/ProductRegistrationsApi/BasicUDI";
    dataTableStructure.pageTitle = "Basic UDI-DIs";
    dataTableStructure.singleItemTitle = "Basic UDI";
    dataTableStructure.entityType = "basic-udis";
    dataTableStructure.pageIcon = "fas fa-barcode";
    dataTableStructure.breadcrumbs = [{ "Name": "Products", "Link": "/your-medboard/products/" }, { "Name": "UDIs", "Link": "/your-medboard/product-portfolio/basic-udis/" }]
    dataTableStructure.dataStructure = [];
    dataTableStructure.preLoadItemUrlParamName = "basicudiId";
    dataTableStructure.preLoadItemId = window.preloadBasicUDIId;
    dataTableStructure.eudamedUploadXmlUrl = "/umbraco/api/RIMSProducts/GenerateNewBasicUdiXml/?basicUdiId=";
    dataTableStructure.eudamedUpdateXmlUrl = "/umbraco/api/RIMSProducts/GenerateBasicUdiUpdateXmlById/?basicUdiId=";
    dataTableStructure.eudamedBasicUdiEUUdisUrl = "/umbraco/api/RIMSProducts/GetBasicUdiEUUdis/?basicUdiId=";


    //dataTableStructure.dataStructure.push({ name: "", field: "Id", width: "25px", sortable: false, isSelectItemCheckbox: true });
    dataTableStructure.dataStructure.push({ name: "Basic UDI-DI Code", field: "BasicUDI_DI_Code", width: "200px", sortable: true, renderWith: FieldTypes.FieldType_Text });
    dataTableStructure.dataStructure.push({ name: "Issuing Entity", field: "IssuingEntityBasicUDI_DI", width: "120px", sortable: true, renderWith: FieldTypes.FieldType_Text });
    dataTableStructure.dataStructure.push({ name: "Legal Manufacturer SRN", field: "LegalManufacturerSRN", width: "160px", sortable: true, renderWith: FieldTypes.FieldType_Text });
    dataTableStructure.dataStructure.push({ name: "Applicable Regulation", field: "ApplicableRegulation", width: "380px", sortable: false, renderWith: FieldType_BasicUdiRegulation });
    dataTableStructure.dataStructure.push({ name: "Is it a System / Procedure pack which is a Device in itself", field: "IsItSystemADeviceInItself", width: "220px", sortable: false, renderWith: FieldTypes.FieldType_Text });
    dataTableStructure.dataStructure.push({ name: "Authorised Representative SRN", field: "AuthorisedRepresentative", width: "170px", sortable: false, renderWith: FieldTypes.FieldType_Text });
    dataTableStructure.dataStructure.push({ name: "Risk Class", field: "RiskClass", width: "130px", sortable: false, renderWith: FieldTypes.FieldType_Text });
    dataTableStructure.dataStructure.push({ name: "Device Name", field: "DeviceName", width: "220px", sortable: false, renderWith: FieldTypes.FieldType_Text });
    dataTableStructure.dataStructure.push({ name: "Device Model", field: "DeviceModel", width: "180px", sortable: false, renderWith: FieldTypes.FieldType_Text });

    dataTableStructure.dataUrlParameters = { search: null, page: 1, orderByField: "BasicUDI_DI_Code", orderByType: "ASCENDING", }

    return dataTableStructure;
};
